import React from "react";
import styles from "./SolutionsMainPoints.module.scss";

const SolutionsMainPoints = ({ features }) => {

  
  return (
    <section className={styles.featureGrid}>
      <div className={styles.grid}>
        {features.map((feature, index) => (
          <div key={index} className={styles.featureCard}>
            <img src={feature.icon} alt={feature.title} className={styles.featureImage} />
            <h3 className={styles.featureTitle}>{feature.title}</h3>
            <p className={styles.featureDescription}>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SolutionsMainPoints;
